<template>
  <div class="business-information">
    <fieldset class="info-group">
      <legend>{{ $t("kyc.section.businessInformation") }}</legend>
    </fieldset>
    <vuestic-widget id="dategridPayOrder">
      <div class="table-responsive">
        <table class="table table-striped first-td-padding">
          <thead>
            <tr>
              <th v-for="(item,index) in tableHeaderList"
                  :key="index">
                {{ item.label | translate}}
              </th>
            </tr>
          </thead>
          <tbody v-if="currentList">
            <tr v-for="(item,index) in currentList"
                :key="index">
              <td>{{ item.app_name }}</td>
              <td>{{ item.website }}</td>
              <td>{{ item.industry }}</td>
              <td>{{ item.complaint_email }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11"
                  v-text="$t('t.noDataNoOrder')"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="block"
           v-if="isMobile === 'pc'">
        <pagination v-show="total>0"
                    :total="total"
                    :page-size="limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :page.sync="page"
                    :limit.sync="limit"
                    :pageSizes="pageSizes"
                    @pagination="orderData" />
      </div>
      <div class="block"
           v-else>
        <pagination v-show="total>0"
                    :total="total"
                    layout="total, prev, pager, next"
                    background
                    :page.sync="page"
                    :limit.sync="limit"
                    :pageSizes="pageSizes"
                    @pagination="orderData" />
      </div>
    </vuestic-widget>
  </div>

</template>
<script>
import Pagination from '@/components/Pagination'
import mixin from '../mixins/mixin'
export default {
  mixins: [mixin],
  props: {
    kycStatus: {
      type: String,
    },
    merchantData: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    Pagination,
  },
  data () {
    return {
      tableHeaderList: [
        { label: 'kyc.businessInformation.appName', key: 'app_name', id: 0 },
        {
          label: 'kyc.businessInformation.website',
          key: 'website',
          id: 1,
        },
        { label: 'kyc.businessInformation.industry', key: 'Industry', id: 2 },
        {
          label: 'kyc.businessInformation.complaintEmail',
          key: 'complaint_email',
          id: 3,
        },
      ],
      list: null, // 请求回来填充表格的数据
      currentList: null,
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 12, // 默认一次显示12条数据
      pageSizes: [6, 10, 12, 50, 100],

      value_mode: '',
      value_time: '',
      searchVal: '',

      showColumnsList: {
        transactionId: true,
        merchantReference: true,
        appName: true,
        referenceDateTime: true,
        method: true,
        amount: true,
        status: true,
        muid: true,
        email: true,
        subject: true,
        updateTime: true,
      },
    }
  },
  mounted () {
    let that = this
    if (this.kycStatus === 'firstEdit') {
      this.getMerchantKYCInfo(4, res => {
        that.setBusinessInfo(res.business_info_page)
        that.limit = 12
        that.getCurrentList()
      })
    } else if (this.merchantData.business_info_page) {
      that.setBusinessInfo(this.merchantData.business_info_page)
      that.$nextTick(() => {
        that.limit = this.merchantData.is_submited || this.merchantData.is_submited.is_saved ? 6 : 12
        that.getCurrentList()
      })
    } else {}
  },
  computed: {
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return 'mobile'
      }
      return 'pc'
    }
  },
  // this.loadingFullScreen('searching', 'Searching', 'fa fa-hourglass-half')
  methods: {
    setBusinessInfo (info) {
      if (!info) return
      this.list = info.data_list
      this.total = info.total
      this.page = info.page
      this.getCurrentList()
    },
    getCurrentList () {
      if (this.list.length > 0) {
        let begin = this.limit * (this.page - 1)
        let end = this.limit * this.page
        this.currentList = this.list.slice(begin, end)
      }
    },
    saveBusinessInformation (cb) {
      let params = {
        page: 4,
        business_info_list: {}
      }
      this.$emit('updateKycInformation', params, function () {
        let flag = true
        cb(flag)
      })
    },
    loadingFullScreen (controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    orderData () {
      this.getCurrentList()
    }
  },
}
</script>
<style lang="scss" scoped>
.business-information {
  width: 100%;
  .form-group {
    width: 100%;
  }
  /deep/ .select-form-group {
    margin-bottom: 0;
  }
  /deep/ .vuestic-scrollbar {
    overflow-y: scroll;
  }

  .first-td-padding td:first-child {
    padding-left: 0.5rem !important;
  }

  .table th {
    text-align: center;
  }
  .table td {
    text-align: center;
  }
  .alink {
    color: $vue-green;
    text-decoration: underline;
  }

  /*  增加详情页面 */
  table {
    text-align: center;
  }

  /deep/ #dategridPayOrder.vuestic-widget {
    .vuestic-widget-body {
      padding: 0;
    }
  }
  @media only screen and (max-width: 750px) {
    .mobile-btn {
      padding: 0.5rem 0.2rem 0;
    }

    /deep/ .pagination-container {
      padding: 5px 4px 10px;
      .el-pagination__total {
        display: block;
        margin-right: 4px;
      }
      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        margin: 0 2px 0;
      }
    }

    /deep/ .pagination-container {
      padding: 5px 4px 10px;
      .el-pagination {
        padding: 0;
      }
      .el-pagination__total {
        display: block;
        margin-right: 4px;
      }
      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        margin: 0 1px 0;
      }
    }

    /deep/ .buyer {
      padding-left: 5px;
      width: auto !important;
    }

    #paymentDetails {
      /deep/ .el-dialog {
        overflow: hidden;
        .vuestic-widget .vuestic-widget-body {
          overflow-x: auto;
          padding: 0.2rem;
        }
      }
    }
    #details {
      min-width: 600px;
    }
    /deep/ .merchant {
      margin-right: 20px;
    }
  }
}
</style>
